export default "__VITE_ASSET__Dw7h752B__"